import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography, Box, Paper, Tabs, Tab } from '@material-ui/core';

import { unsaveJob } from '../../../actions/userActions';
import Alert from '../../../utils/alert';
import Spinner from '../../common/Spinner';
import SavedJobList from './SavedJob/SavedJobList';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(3, 0),
    },
    heading: {
        marginBottom: theme.spacing(4),
        textAlign: 'center',
        fontFamily: 'Kosugi Maru, sans-serif',
    },
    tabsContainer: {
        backgroundColor: '#fff',
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(3),
    },
    tabs: {
        '& .MuiTab-root': {
            minWidth: 120,
            fontSize: '1.4rem',
            textTransform: 'none',
        },
    },
    tabPanel: {
        padding: theme.spacing(3, 0),
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const classes = useStyles();

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`saved-job-tabpanel-${index}`}
            aria-labelledby={`saved-job-tab-${index}`}
            className={classes.tabPanel}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

const SavedJob = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const savedJobList = useSelector(state => state.user.savedJobList);
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        if (!savedJobList) return;
    }, [savedJobList]);

    const handleRemoveItem = id => {
        Alert.confirm('この求人を保存リストから削除しますか？')
            .then((result) => {
                if (result.value) {
                    dispatch(unsaveJob(id));
                }
            });
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const savedJobsNotApplied = savedJobList ? savedJobList.filter(savedJob => !savedJob.applied) : [];
    const appliedJobs = savedJobList ? savedJobList.filter(savedJob => savedJob.applied) : [];

    return (
        <Box className={classes.root}>
            <Container>
                <Typography variant="h4" component="h1" className={classes.heading}>
                    保存済み求人広告リスト
                </Typography>

                <Paper className={classes.tabsContainer} elevation={1}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        className={classes.tabs}
                        centered
                    >
                        <Tab label="保存リスト" id="saved-job-tab-0" aria-controls="saved-job-tabpanel-0" />
                        <Tab label="応募済み" id="saved-job-tab-1" aria-controls="saved-job-tabpanel-1" />
                    </Tabs>
                </Paper>

                <TabPanel value={tabValue} index={0}>
                    {false ? (
                        <Spinner />
                    ) : (
                        <SavedJobList
                            onClickDelete={(id) => handleRemoveItem(id)}
                            savedJobList={savedJobsNotApplied}
                        />
                    )}
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                    {false ? (
                        <Spinner />
                    ) : (
                        <SavedJobList
                            onClickDelete={(id) => handleRemoveItem(id)}
                            savedJobList={appliedJobs}
                            applied={true}
                        />
                    )}
                </TabPanel>
            </Container>
        </Box>
    );
};

export default SavedJob;
